import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoOperacaoContaOrdemMultiselectComponent } from './novo-operacao-conta-ordem-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoOperacaoContaOrdemMultiselectComponent],
  exports: [NovoOperacaoContaOrdemMultiselectComponent]
})
export class NovoOperacaoContaOrdemMultiselectModule {}
